import HttpHelpers from '../helpers';

const BookingsApiEndpoints = {
  getBookings: (params) => {
    return HttpHelpers.authenticatedAxios
      .get('host/booking', { params })
      .then((response) => response.data);
  },
  getBookingDetails: (bookingId) => {
    return HttpHelpers.authenticatedAxios
      .get(`host/booking/${bookingId}`)
      .then((response) => response.data);
  },
  rejectBooking: (bookingId, data) => {
    return HttpHelpers.authenticatedAxios
      .post(`host/booking/${bookingId}/reject`, data)
      .then((response) => response.data);
  },
  approveBooking: (bookingId, data) => {
    return HttpHelpers.authenticatedAxios
      .post(`host/booking/${bookingId}/confirm`, data)
      .then((response) => response.data);
  },
  reviewBooking: (reviewId, data) => {
    return HttpHelpers.authenticatedAxios
      .put(`host/booking/review/${reviewId}`, data)
      .then((response) => response.data);
  },
};

export default BookingsApiEndpoints;
